import { computed, defineComponent } from 'vue';
import { ComponentSize } from '@/models/common/component-size.model';
import { Refresh } from '@element-plus/icons-vue';
import { useDocumentList } from '@/hooks/documents/document-list.composables';
import { useDocumentListStore } from '@/store/documents/document-list.store';
import { storeToRefs } from 'pinia';
import { useDocumentListFilter } from '@/hooks/documents/document-list-filter.composables';
import { AdminTakenTag } from '@/models/common/admin-taken-tag.model';

const icons = {
  Refresh,
};

export default defineComponent({
  name: 'DocumentListHeader',
  setup() {
    const { loadDocumentList } = useDocumentList();
    const { submitAndValidateForm } = useDocumentListFilter();

    const documentListStore = useDocumentListStore();
    const { isDocumentListLoading, adminTakenPlayerCount } = storeToRefs(documentListStore);

    const search = async (): Promise<void> => {
      if (!(await submitAndValidateForm())) {
        return;
      }

      await loadDocumentList();
    };

    const isPlayerTakenByAdmin = computed<boolean>(
      () => adminTakenPlayerCount.value > 0,
    );

    const adminTakenPlayerCountTag = computed<AdminTakenTag>(() => ({
      type: isPlayerTakenByAdmin.value ? 'warning' : 'info',
      effect: isPlayerTakenByAdmin.value ? 'dark' : 'plain',
      text: isPlayerTakenByAdmin.value
        ? `You have ${adminTakenPlayerCount.value} taken players in current list`
        : 'No taken players in current list',
    }));

    return {
      icons,
      ComponentSize,
      isDocumentListLoading,
      search,
      adminTakenPlayerCountTag,
    };
  },
});
